import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-close-account-status',
	templateUrl: './status.component.html',
	styleUrls: ['./status.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CloseAccountStatusComponent implements OnInit {

	constructor(private router: Router) {}

	ngOnInit(): void {

	}

	redirectTo = (url: string = '') => this.router.navigate([url]);
	goToInitial = () => this.redirectTo('');

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/close-account/status/status.component.ts